/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { map, Observable } from 'rxjs';

// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { BilancioConsolidato } from '@ideapa/app-shared-bilancio-consolidato';
import { Ente } from '@ideapa/app-shared-ente';
import { BilancioConsolidatoDto } from '@ideapa/common-dto';
import { SoggettoPerConsolidato } from '@ideapa/common-utils';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class BilancioConsolidatoApiClient extends BaseCRUDApiClient<BilancioConsolidatoDto> {
  baseUrl = this.config.apiEndpoint + '/bilancio-consolidato';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  calcolaConsolidato() {
    this._pagedCache.clear();
    return this.http.get(this.baseUrl + '/calcola-consolidato');
  }

  getSoggettiPerConsolidato(ente: Ente) {
    return this.http.post<SoggettoPerConsolidato[]>(
      this.baseUrl + '/soggetti-per-consolidato',
      { ente: ente }
    );
  }

  downloadExcelConsolidato(
    idBilancio: number,
    idProspetto: number,
    fileName: string
  ): Observable<ArrayBuffer> {
    return this.http
      .post(
        this.baseUrl + '/download-excel-consolidato',
        {
          idBilancio: idBilancio,
          idProspetto: idProspetto,
          fileName: fileName,
        },
        {
          responseType: 'arraybuffer',
        }
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        })
      );
  }

  downloadPdfConsolidato(
    idProspetto: number,
    escludiPreconsolidamento: boolean,
    escludiElisione: boolean,
    fileName: string
  ): Observable<ArrayBuffer> {
    return this.http
      .post(
        this.baseUrl + '/download-pdf-consolidato',
        {
          idProspetto: idProspetto,
          escludiPreconsolidamento: escludiPreconsolidamento,
          escludiElisione: escludiElisione,
          fileName: fileName,
        },
        {
          responseType: 'arraybuffer',
        }
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        })
      );
  }

  chiusuraConsolidato() {
    this._pagedCache.clear();
    return this.http.get(`${this.baseUrl}/chiusura-consolidato`);
  }

  riaperturaConsolidato() {
    this._pagedCache.clear();
    return this.http.get(`${this.baseUrl}/riapertura-consolidato`);
  }

  checkConsolidato(anno: number | undefined = undefined) {
    return this.http.post<BilancioConsolidato | null>(
      `${this.baseUrl}/check-consolidato`,
      { anno }
    );
  }

  // calcolaBilanciConsolidatiAnno(anno: number) {
  //   return this.http.get(
  //     `${this.baseUrl}/calcola-bilanci-consolidati/${anno}`,
  //     {}
  //   );
  // }
}
